// Loss = stat hits 0 or 100. Win = survive 60 days; flavor depends on stat blend.

export const LOSS_ENDINGS = {
  e0:   { id: 'e0',   title: 'Quietly Ignored',
          line: 'Engineering stopped reading your Slack messages on day 47.',
          color: '#4CEB9F', glyph: 'ghost' },
  e100: { id: 'e100', title: 'Engineering Captured',
          line: "You're a PM-in-name. The tech leads decide what ships now.",
          color: '#4CEB9F', glyph: 'puppet' },
  x0:   { id: 'x0',   title: 'Fired',
          line: 'The CEO needed a scapegoat for the missed quarter. You were the newest.',
          color: '#6B53FD', glyph: 'exit' },
  x100: { id: 'x100', title: 'Exec Puppet',
          line: 'You ship the OKR slide every Friday. Nothing else has shipped in weeks.',
          color: '#6B53FD', glyph: 'deck' },
  u0:   { id: 'u0',   title: 'It Flopped',
          line: 'The launch went out. Nobody noticed it shipped.',
          color: '#EF7E46', glyph: 'tumbleweed' },
  u100: { id: 'u100', title: 'Scope Spiral',
          line: 'Every feature on the wall got built. None of them got used.',
          color: '#EF7E46', glyph: 'scope' },
  p0:   { id: 'p0',   title: 'Burnt Out',
          line: 'Took medical leave on day 73. Your laptop is still on the desk.',
          color: '#FDBC45', glyph: 'candle' },
  p100: { id: 'p100', title: 'Manic Spiral',
          line: '47-page strategy doc. Tuesday at 3 a.m. Nobody asked for it.',
          color: '#FDBC45', glyph: 'spiral' },
};

// Win endings — pick the BEST-matching profile from the four stats.
export const WIN_ENDINGS = [
  { id: 'w_cpo',       title: 'Reluctant CPO',
    line: "The board wants you in the corner office. You're not sure you want it.",
    color: '#6B53FD', glyph: 'crown',
    test: (s) => s.x >= 70 && s.e <= 60 },
  { id: 'w_shipped',   title: 'PM Who Shipped',
    line: 'You shipped the thing. People use it. The team is still here.',
    color: '#4CEB9F', glyph: 'rocket',
    test: (s) => s.u >= 65 && s.e >= 60 },
  { id: 'w_hero',      title: 'Internal Hero, External Mystery',
    line: 'Engineering loves you. Marketing has never heard of you.',
    color: '#FFC5F6', glyph: 'shield',
    test: (s) => s.e >= 70 && s.u <= 60 },
  { id: 'w_whisperer', title: 'Roadmap Whisperer',
    line: 'Nothing was perfect. Nothing was on fire. The team trusts you.',
    color: '#FDBC45', glyph: 'compass',
    test: (s) => Object.values(s).every((v) => v >= 40 && v <= 70) },
  { id: 'w_survivor',  title: 'You Survived 90 Days',
    line: "You're still here. That's most of it.",
    color: '#0F0F0F', glyph: 'calendar',
    test: () => true },
];

export const TOTAL_ENDINGS = Object.keys(LOSS_ENDINGS).length + WIN_ENDINGS.length;
